(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tx-feedback"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.tx-rating').forEach(function(group){
  function paint(){
    var checked=group.querySelector('input:checked');
    group.querySelectorAll('label[data-score]').forEach(function(label){
      label.dataset.filled=String(!!checked && Number(label.dataset.score)<=Number(checked.value));
    });
  }
  group.addEventListener('change',paint);
  paint();
});
var feedback=document.getElementById('tx-feedback');
if(feedback){
  var params=new URLSearchParams(location.search);
  var tracking=document.getElementById('tx-feedback-tracking');
  var order=document.getElementById('tx-feedback-order');
  if(tracking) tracking.value=(params.get('nums')||params.get('num')||'').slice(0,80);
  if(order) order.value=(params.get('order')||'').slice(0,41);
  if(params.get('review')==='1') feedback.hidden=false;
  var feedbackForm=document.getElementById('HemingwayFeedback');
  var status=document.getElementById('tx-feedback-status');
  feedbackForm.addEventListener('submit',async function(event){
    event.preventDefault();
    if(!feedbackForm.reportValidity()) return;
    var button=feedbackForm.querySelector('button[type="submit"]');
    button.disabled=true;
    status.hidden=true;
    var payload={
      number:tracking.value,order:order.value,
      email:document.getElementById('tx-feedback-email').value,
      reason:document.getElementById('tx-feedback-reason').value
    };
    ['shipping','support','product'].forEach(function(key){
      payload[key]=Number(feedbackForm.querySelector('input[name="contact['+key+' rating]"]:checked').value);
    });
    try{
      var response=await fetch(feedbackForm.dataset.api.replace(/\/$/,'')+'/api/feedback',{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)
      });
      var result=await response.json();
      if(!response.ok||!result.ok) throw new Error(result.error||feedback.dataset.error);
      status.textContent=feedback.dataset.success;
      status.hidden=false;
      feedbackForm.hidden=true;
      feedback.dataset.submitted='true';
    }catch(error){
      status.textContent=error.message||feedback.dataset.error;
      status.hidden=false;
      button.disabled=false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
